import { createRouter, createWebHashHistory } from "vue-router";
import { setToken, getToken, removeToken } from "@/utils/auth";

const routes = [
  {
    path: "/login",
    name: "loginComponent",
    component: () => import("@/components/loginComponent"),
  },
  {
    path: "/",
    name: "mainIndex",
    component: () => import("@/components/mainIndex"),
  },
];

// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
export default router;
// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  const islogin =
    localStorage.getItem("push-name") != null &&
    localStorage.getItem("push-name") != "undefined" &&
    localStorage.getItem("push-password") != null &&
    localStorage.getItem("push-password") != "undefined";
  if (to.path !== "/login" && !islogin) {
    // 如果不是登录页面且用户未登录，则重定向到登录页面
    next("/login");
  } else {
    // 否则，继续路由导航
    next();
  }
});
